import Vue from 'vue';

Vue.filter('lineBreak', function(value) {

    if(!value) return '';

    value = value.toString();

    return value.replace(/(?:\r\n|\r|\n)/g, '<br />').trim();
});
